<template>
  <v-container fluid>
    <v-row dense>
      <v-col cols="12" justify="center">
        <v-card class="mx-auto text-center black--text" outlined>
          問い合わせ一覧
        </v-card>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12" sm="3" md="3" lg="3" xl="3">
        <!-- 検索用のテキスト入力 -->
        <v-autocomplete
          v-model="groupFilterValue"
          label="グループ指定"
          placeholder="グループ指定"
          :items="groupNames"
          outlined
          dense
          clearable
          hide-details="auto"
          background-color="white"
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" sm="3" md="3" lg="3" xl="3">
        <!-- 検索用のテキスト入力 -->
        <v-autocomplete
          v-model="postUsersFilterValue"
          label="作成者指定"
          placeholder="作成者指定"
          :items="postUsers"
          outlined
          dense
          clearable
          hide-details="auto"
          background-color="white"
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" sm="3" md="3" lg="3" xl="3">
        <!-- 検索用の年度入力 -->
        <v-autocomplete
          v-model="selectNendo"
          label="年度指定"
          placeholder="年度指定"
          :items="nendoList"
          @change="reload"
          outlined
          dense
          hide-details="auto"
          background-color="white"
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" sm="3" md="3" lg="3" xl="3">
        <v-switch 
          v-model="viewFavoriteOnly"
          dense
          class="mt-1"
          label="お気に入りのみ"
          hide-details="auto"
        />
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12" justify="center">
        <v-data-table
          :headers="headers"
          :items="contacts"
          :items-per-page.sync="perPage"
          :footer-props="{'items-per-page-options': [10, 20, 30, 50, 100, -1]}"
          dense
          disable-sort
          :loading="isContactsLoding" loading-text="読込中"
          >
          <!-- 投稿日と投稿者 -->
          <template #[`item.postUser`]="{ item }">
            <v-row dense><v-col cols="12" justify="center">{{ item.postDate }}</v-col></v-row>
            <v-row dense><v-col cols="12" justify="center">{{ item.postUser }}</v-col></v-row>
          </template>
          <!-- グループ名と代表者 -->
          <template #[`item.groupName`]="{ item }">
            <v-row dense><v-col cols="12" justify="center">{{ item.groupName }}</v-col></v-row>
            <v-row dense><v-col cols="12" justify="center">{{ item.ownerUser }}</v-col></v-row>
          </template>
          <!-- 対象/コメントフラグ -->
          <template #[`item.target`]="{ item }">
            <v-row dense>
              <v-col cols="12" justify="center">
                <v-icon x-large v-if="item.studentFlg">$student</v-icon>
                <v-icon x-large v-if="item.parentFlg">$parent</v-icon>
                <v-icon x-large v-if="item.teacherFlg">$teacher</v-icon>
                <div v-if="item.targetSelectFlg">【限定】</div>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12" justify="center">
                <v-icon class="ml-2" v-if="item.commentFlg">mdi-comment-text-outline</v-icon>
              </v-col>
            </v-row>
          </template>
          <!-- お気に入り -->
          <template #[`item.favoriteFlg`]="{ item }">
            <v-btn icon outlined @click="changeFavoriteContacts(item)" v-if="item.favoriteFlg"><v-icon color="orange">mdi-star</v-icon></v-btn>
            <v-btn icon outlined @click="changeFavoriteContacts(item)" v-if="!item.favoriteFlg"><v-icon>mdi-star-outline</v-icon></v-btn>
          </template>
          <!-- 編集と通知 -->
          <template #[`item.editAndMail`]="{ item }">
            <v-row dense>
              <v-col cols="12" justify="center">
                <v-btn icon outlined @click="onClickEditItem(item)">
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12" justify="center" style="white-space : nowrap;">
                <v-btn icon outlined @click="openMailModal(item)" v-if="tounendo == selectNendo">
                  <v-icon>mdi-email-plus-outline</v-icon>
                </v-btn>
                <v-btn icon outlined @click="onClickMailLog(item)">
                  <v-icon>mdi-email-search-outline</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </template>
          <!-- 公開期間 -->
          <template #[`item.publishDate`]="{ item }">
            <v-row dense><v-col cols="12" justify="center" style="white-space : nowrap;">{{ item.openDate }}～</v-col></v-row>
            <v-row dense><v-col cols="12" justify="center" style="white-space : nowrap;">{{ item.closeDate }}</v-col></v-row>
          </template>
          <!-- 公開状態 -->
          <template #[`item.isOpen`]="{ item }">
            <v-btn color="accent" class="black--text" v-if="item.publishFlg && tounendo == selectNendo && !item.beforeOpeningFlg" @click="onClickChangeOpenStatus(item)">公開中</v-btn>
            <v-btn color="white" class="black--text" v-if="item.publishFlg && tounendo == selectNendo && item.beforeOpeningFlg" @click="onClickChangeOpenStatus(item)">公開前</v-btn>
            <v-btn color="grey" class="black--text" v-if="!item.publishFlg && tounendo == selectNendo" @click="onClickChangeOpenStatus(item)">停止中</v-btn>
            <v-btn color="grey" class="black--text" v-if="tounendo != selectNendo" :disable="true">停止中</v-btn>
          </template>
          <!-- ユーザー閲覧数 -->
          <template #[`item.count`]="{ item }">
            <v-btn :loading="item.isCountLoading" @click="onClickReceiptStatus(item)">{{ item.count }}</v-btn>
          </template>
          <!-- 操作 -->
          
          <template #[`item.action`]="{ item }">
            <v-row dense>
              <v-col cols="12" justify="center">
                <v-btn icon outlined @click="onClickExcelExport(item)">
                  <v-icon color="green">mdi-file-excel</v-icon>
                </v-btn>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12" justify="center">
                <v-btn icon outlined @click="onClickDeleteItem(item)" v-if="tounendo == selectNendo">
                  <v-icon color="red">mdi-delete</v-icon>
                </v-btn>
                <v-btn icon outlined v-if="tounendo != selectNendo" :disable="true">
                  <v-icon color="grey">mdi-delete</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-btn fixed fab bottom color="secondary" @click="reload" style="bottom: 50px">
      <v-icon color="white">mdi-refresh</v-icon>
    </v-btn>
    <!-- メール送信モーダル -->
    <v-dialog
      v-model="mailDialog"
      max-width="290"
    >
      <v-card>
        <v-card-title class="ml-12">連絡を通知する</v-card-title>
        <v-list-item-subtitle class="ml-3" style="font-size:.835rem;">非公開の場合は公開になり次第通知されます</v-list-item-subtitle>
        <v-card-text>
          <v-radio-group v-model="mailType" :mansdatory="false">
            <v-radio label="連絡の登録を通知する" value="0"></v-radio>
            <v-radio label="連絡の修正を通知する" value="1"></v-radio>
            <v-radio label="未読者に対して再通知する" value="2"></v-radio>
          </v-radio-group>
        </v-card-text>
        <v-card-actions>
          <v-row dense>
            <v-col cols="4" class="ml-1" justify="center">
              <v-btn block color="grey" @click="mailDialog = false">
                閉じる
              </v-btn>
            </v-col>
            <v-col cols="3" justify="center"></v-col>
            <v-col cols="4" class="ml-1" justify="center">
              <v-btn block color="accent" @click="sendMail()">
                送信予約
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- エクセル出力モーダル -->
    <v-dialog
      v-model="exportDialog"
      max-width="290"
    >
      <v-card>
        <v-card-title style="font-size:1.23rem;">連絡の閲覧状況を出力する</v-card-title>
        <v-card-text>
          連絡の閲覧状況をExcelにて出力可能です。
          システムによるファイルの準備ができましたら、
          <p class="font-weight-bold red--text">メールアドレス宛にダウンロード用のリンクを送付します</p>
        </v-card-text>
        <v-card-actions>
          <v-row dense>
            <v-col cols="4" class="ml-1" justify="center">
              <v-btn block color="grey" @click="exportDialog = false">
                閉じる
              </v-btn>
            </v-col>
            <v-col cols="3" justify="center"></v-col>
            <v-col cols="4" class="ml-1" justify="center">
              <v-btn block color="accent" :disabled="exportDisabled" @click="exportExcelContactStatus()">
                出力予約
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- 通知履歴モーダル -->
    <v-dialog
      v-model="mailLogDialog"
      max-width="1200"
    >
      <v-card>
        <v-card-title class="pl-5" style="font-size:1.012rem;">通知履歴</v-card-title>
        <v-card-subtitle class="pl-5">※完了まで数分かかる場合があります</v-card-subtitle>
        <v-card-subtitle class="pl-5">※通知可能なメールもしくはスマホアプリを１件としてカウントしています</v-card-subtitle>
        <v-card-text>
          <v-data-table
            :headers="mailLogHeader"
            :items="mailLogList"
            :items-per-page="-1"
            dense
            disable-sort
            hide-default-footer
          >
          <template #[`item.cancel`]="{ item }">
            <v-btn color="green" small class="white--text" v-if="item.status == '0' || item.status == '1'" @click="cancelNotification(item)">キャンセル</v-btn>
          </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>
  
<script>
import { httpsCallable, getFunctions } from "firebase/functions";

export default {
  data() {
    return {
      postUsersFilterValue: "",
      groupFilterValue: "",
      tounendo: "",
      selectNendo: "",
      nendoList : [],
      viewFavoriteOnly: false,
      postUsers : [],
      groupNames : [],
      headers: [
        { text: "作成日時/作成者", value: "postUser", width: "15%", filter: this.postUserFilter },  
        { text: "タイトル", value: "title", width: "35%" },
        { text: "グループ名/代表者", value: "groupName", width: "35%", filter: this.groupNameFilter },
        { text: "対象/コメント", value: "target" },
        { text: "お気に入り", value: "favoriteFlg", width: "5%", filter: this.favoriteFilter },
        { text: "編集/通知", value: "editAndMail", width: "5%" },
        { text: "公開期間", value: "publishDate", width: "20%" },
        { text: "公開状態", value: "isOpen", width: "5%" },
        { text: "全体：既読：未読", value: "count", width: "5%" },
        { text: "操作", value: "action", width: "5%" },
      ],
      contacts: [],
      isContactsLoding: false,
      mailDialog: false,
      mailContactId: "",
      mailType: "1",
      exportDialog: false,
      exportContactId: "",
      exportDisabled: false,
      mailLogDialog: false,
      mailLogHeader: [
        { text: "登録日時", value: "insDate"},
        { text: "通知区分", value: "typeNm"},
        { text: "通知設定者", value: "postUser"},
        { text: "状態", value: "statusNm"},
        { text: "全件数", value: "allCount"},
        { text: "通知済件数", value: "doneCount"},
        { text: "未通知件数", value: "notYetCount"},
        { text: "通知完了日時", value: "updDate"},
        { text: "キャンセル", value: "cancel"},
      ],
      mailLogList: [],
      perPage: 30,
    };
  },
  // 初期表示時データ読み込み
  async created() {
    this.perPage = this.$store.state.parPageContactList;
    const functions = getFunctions(this.$firebase);
    functions.region = "asia-northeast1";
    const schoolAidSupportLogined = httpsCallable(functions,"schoolAidSupportLogined");
    await schoolAidSupportLogined({funcName: "commonGetNendo"}).then((ret) => {
      this.tounendo = ret.data.tounendo;
      this.selectNendo = ret.data.tounendo;
      this.nendoList = ret.data.list;
    });
    await this.reload();
  },
  watch: {
    perPage: function(newVal) {
      this.$store.dispatch('setParPageContactList', newVal);
    },
  },
  methods: {
    // 投稿者名フィルタ
    postUserFilter(value) {
      if (!this.postUsersFilterValue) {
        return true;
      }
      return value.toString().includes(this.postUsersFilterValue);
    },
    // グループ名フィルタ
    groupNameFilter(value) {
      if (!this.groupFilterValue) {
        return true;
      }
      return value.toString().includes(this.groupFilterValue);
    },
    // お気に入りフィルタ
    favoriteFilter(value) {
      if (!this.viewFavoriteOnly) {
        return true;
      }
      return value;
    },
    async changeFavoriteContacts(item)  {      
      const functions = getFunctions(this.$firebase);
      functions.region = "asia-northeast1";
      const schoolAidSupportLogined = httpsCallable(functions,"schoolAidSupportLogined");
      var data = {
        funcName: "changeFavoriteContacts",
        contactId: item.contactId,
        favoriteFlg: item.favoriteFlg
      };
      await schoolAidSupportLogined(data);
      item.favoriteFlg = !item.favoriteFlg;
    },
    async reload() {
      var temp_postUsers = new Set();
      var temp_groupNames = new Set();
      this.contacts = [];
      const functions = getFunctions(this.$firebase);
      functions.region = "asia-northeast1";
      const schoolAidSupportLogined = httpsCallable(functions, "schoolAidSupportLogined");
      this.isContactsLoding = true;
      var param = {
        funcName:"loadContactList",
        nendo: this.selectNendo
      }
      await schoolAidSupportLogined(param).then((contacts) => {
        var ret = [];
        contacts.data.forEach((contact) => {
          temp_postUsers.add(contact.postUser);
          temp_groupNames.add(contact.groupName);
          var count = contact.allCount + "：" + contact.readCount + "：" + contact.unreadCount;
          var row = {
            postDate: contact.postDate,
            postUser: contact.postUser,
            groupName : contact.groupName,
            ownerUser : contact.ownerUser,
            studentFlg: contact.studentFlg,
            parentFlg: contact.parentFlg,
            teacherFlg: contact.teacherFlg,
            title : contact.title,
            openDate: contact.openDate,
            closeDate: contact.closeDate,
            publishFlg : contact.publishFlg,
            count : count,
            allCount : contact.allCount,
            contactId : contact.contactId,
            isCountLoading: contact.isCountLoading,
            commentFlg: contact.commentFlg,
            favoriteFlg: contact.favoriteFlg,
            targetSelectFlg: contact.targetSelectFlg,
            beforeOpeningFlg: contact.beforeOpeningFlg,
          };

          ret.push(row);
        });
        this.contacts = ret;
        this.isContactsLoding = false;
        this.postUsers = Array.from(temp_postUsers);
        this.groupNames = Array.from(temp_groupNames);
      });
    },

    // 公開状態変更
    async onClickChangeOpenStatus(item) {
      var result = confirm("公開状態を変更してよろしいですか？");
      if (!result) {
        return;
      }

      // ローディング開始
      this.$root.loading = true;
      const functions = getFunctions(this.$firebase);
      functions.region = "asia-northeast1";
      var param = {
        funcName: "changeOpenStatus",
        contactId: item.contactId,
        publishFlg: item.publishFlg,
      };
      const schoolAidSupportLogined = httpsCallable(functions, "schoolAidSupportLogined");
      await schoolAidSupportLogined(param);
      // ローディング終了
      this.$root.loading = false;
      await this.reload();
    },

    // 問い合わせ修正
    onClickEditItem(item) {
      this.$router.push({
        name: "ContactEdit",
        params: {
          id: item.contactId,
        }
      });
    },
    // 論理削除
    async onClickDeleteItem(item) {
      var result = confirm("削除してよろしいですか？");
      if (!result) {
        return;
      }

      // ローディング開始
      this.$root.loading = true;
      const functions = getFunctions(this.$firebase);
      functions.region = "asia-northeast1";
      var param = {
        funcName: "deleteContact",
        contactId: item.contactId,
      };
      const schoolAidSupportLogined = httpsCallable(functions, "schoolAidSupportLogined");
      await schoolAidSupportLogined(param);
      // ローディング終了
      this.$root.loading = false;
      await this.reload();
    },
  },
};
</script>

<style scoped>
.modal-header, .modal-body {
  padding: 5px 25px;
}
.modal-header {
  border-bottom: 1px solid #ddd;
}

</style>